// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/NewAccount.scss
// module id = ./src/styles/NewAccount.scss
// module chunks = 0